module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kerry Newcomb, Frank Schaefer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kerry Newcomb was born in Milford, Connecticut, but had the good fortune to be raised in Texas. He has served in the Jesuit Volunteer Corps and taught at the St. Labre Mission School on the Northern Cheyenne Reservation in Montana, and holds a master’s of fine arts degree in theater from Trinity University. Newcomb has written plays, film scripts, commercials, and liturgical dramas, and is the author of over thirty novels. He lives with his family in Fort Worth, Texas."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Rn6AnY/tc-custom/9781497691865.jpg?1705633988833",
      "alt": "This image is the cover for the book Paxton and the Gypsy Blade, The Paxton Saga"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Paxton and the Gypsy Blade, The Paxton Saga\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("To avenge her brother, a Gypsy girl will travel the world")]), _c('br'), _c('br'), _vm._v(" Adriana was only a child when she watched her parents die. As hateful villagers attacked her family’s camp, Adriana’s brother Giuseppe carried her into the woods. He told her to close her eyes, but she watched the carnage, and the memory has stayed with her ever since. Now a young woman, she is on the verge of choosing a husband when her life is again turned upside down. At a quiet English village fair, Adriana is telling fortunes when one of the local nobility attempts to have his way with her. Giuseppe is killed while defending her honor, and Adriana vows revenge."), _c('br'), _c('br'), _vm._v(" England offers no justice for Gypsies, and so Adriana must take her vengeance in blood. When her plot against her brother’s killer fails, she is forced to flee to the New World, where she will encounter a passion greater than any she has ever known.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0